import { useEffect, useState } from "react";
import { useGetProfileUpdateSettingsMutation, useSetProfileUpdateSettingsMutation } from "../../../api/ProfileAPI";

type settings = {
  messageOnStatusChangedToFertig: boolean;
}

interface ThisProps {
}

const AccountSettingsComponent: React.FC<ThisProps> = (props) => {

  const [getSettingsAPI] = useGetProfileUpdateSettingsMutation();
  const [setSettingsAPI] = useSetProfileUpdateSettingsMutation();

  const [settings, setSettings] = useState<settings>();

  const messageOnStatusChangedToFertigHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({ ...settings, messageOnStatusChangedToFertig: e.target.checked });
  }

  useEffect(() => {
    if (!settings) return;
    setSettingsAPI(settings).unwrap()
      .catch((err) => console.log(err));
  }, [settings]);

  useEffect(() => {
    getSettingsAPI().unwrap()
      .then((data) => setSettings(data))
      .catch((err) => console.log(err));
  }, [getSettingsAPI]);

  return (
    <>

      <h4 style={{ marginTop: "50px" }}>Einstellungen</h4>

      {settings &&
        <>
          <div>
            <span>Nachricht bei Statusänderung zu Fertig: </span><input type="checkbox" checked={settings.messageOnStatusChangedToFertig} onChange={messageOnStatusChangedToFertigHandle} />
          </div>
        </>
      }

    </>
  );
}

export default AccountSettingsComponent;
